import baseUrl, { image } from '../utils/data/baseUrl'
import { birthDate, checkId, checkPhone, checkWord, email, required, username } from './form'
import { safeHTML } from '../utils/safeHTML'
import numWord from '../utils/numWord'
import { GTMQuiz } from './analytics/GTM'
import getCorrectCase from '../utils/getCorrectCase'
import { FRIENDS } from './shared/states/names'
import { defaultStore, stores, conturs, defaultContur } from '../translations'
import { XP } from './game'
import { BLACK_FRIDAY } from './events'
import { tasksForSavingProductsToGA } from './task'
import { ONBOARDING_STEPS_TYPES } from '../providers/onboarding-provider/constants/index'
import { isAlfaGameActive } from '../utils/game/isAlfaGameActive'
import { isJumperForMeAssets } from '../utils/game/isJumperForMeAssets'
import { isJumperAdidasAssets } from '../utils/game/isJumperAdidasAssets'
import { isPlatformBourjoisAssets } from '../utils/game/isPlatformBourjoisAssets'
import { isJumperRimmelAssets } from '../utils/game/isJumperRimmelAssets'

function getJumperPreviewImage() {
  if (isJumperForMeAssets()) {
    return image('games/preview/jumper.png')
  }

  if (isJumperAdidasAssets()) {
    return image('games/preview/jumper-adidas.png')
  }

  if (isJumperRimmelAssets()) {
    return image('games/preview/jumper-rimmel.png')
  }

  return image('games/preview/old/jumper.png')
}

const jumperPreviewImage = getJumperPreviewImage()

function getPlatformPreviewImage() {
  if (isAlfaGameActive()) {
    return image('games/preview/beautypad-alfa-2.jpg')
  }

  if (isPlatformBourjoisAssets()) {
    return image('games/preview/beautypad-bourjois.png')
  }

  if (defaultStore === stores.ae) {
    return image('games/preview/me/beautypad.png')
  }

  return image('games/preview/beautypad.png')
}

const platformPreviewImage = getPlatformPreviewImage()

export const rulesLink = 'https://tamagotchi.goldapple.ru/docs/rules.pdf'

export const editUserLink = 'https://goldapple.ru/customer/account/edit'

export const copyright = 'header.copyright'
export const copyrightParams = { value: new Date().getFullYear() }

const _getSupportLink = (store = defaultStore) => {
  switch (store) {
    case stores.ae:
      return 'https://wa.me/971527732032'
    case stores.qa:
      return 'https://wa.me/97431190811'
    case stores.sa:
      return 'https://wa.me/966543639700'
    default:
      return 'https://wa.me/971527732032'
  }
}

export const defContent = (image) => (typeof image === 'object' ? image['ru'] : image)

const _getHeader = (store = defaultStore) => {
  const supportLink = _getSupportLink(store)

  return {
    menuList: {
      title: 'header.menuList.title',
      customMenuItems: [
        {
          iconM: 'help/mob/1',
          text: 'header.menuList.items.faq',
          className: 'custom-menu__item_faq',
          attr: { modal: { type: 'faqModal', props: {} } },
        },
        {
          iconM: 'help/mob/7',
          text: 'header.menuList.items.conditions',
          linkAttr: {
            tag: 'a',
            target: '_blank',
            href: rulesLink,
            isRules: true,
          },
          className: 'custom-menu__item_rules',
        },
        {
          id: 'restartTutorial',
          iconM: 'help/mob/6',
          text: 'header.menuList.items.rules',
          className: 'custom-menu__item_rules',
          attr: {
            tutorial: {
              action: 'restartTutorial',
            },
          },
        },
        // {
        //   id: 'aboutProject',
        //   iconM: 'help/mob/8',
        //   text: 'header.menuList.items.about',
        //   attr: { modal: [{ type: 'rulesModal', props: {} }] },
        //   className: 'custom-menu__item_rules',
        // },
        defaultContur === conturs.me
          ? {
              icon: 'header/soc/instagram',
              iconM: 'help/mob/instagram',
              text: 'header.menuList.social.instagram',
              className: 'custom-menu__item_soc custom-menu__item_instagram',
              linkAttr: { href: 'https://www.instagram.com/goldapple_me', target: '_blank' },
            }
          : {
              icon: 'header/soc/vk',
              iconM: 'help/mob/3',
              text: 'header.menuList.social.vk',
              className: 'custom-menu__item_soc custom-menu__item_vk',
              linkAttr: { href: 'https://vk.com/goldapple_ru', target: '_blank' },
            },
        defaultContur === conturs.me && {
          icon: 'header/soc/tik-tok',
          iconM: 'help/mob/tik-tok',
          text: 'header.menuList.social.tikTok',
          className: 'custom-menu__item_soc custom-menu__item_tik-tok',
          linkAttr: {
            href: 'https://www.tiktok.com/@goldapple_me',
            target: '_blank',
          },
        },
        defaultContur === conturs.me && {
          icon: 'header/soc/snapchat',
          iconM: 'help/mob/snapchat',
          text: 'header.menuList.social.snapchat',
          className: 'custom-menu__item_soc custom-menu__item_snapchat',
          linkAttr: {
            href: 'https://www.snapchat.com/add/goldapple_me',
            target: '_blank',
          },
        },
        // {
        //   icon: 'header/soc/yt',
        //   iconM: 'help/mob/5',
        //   text: 'header.menuList.social.youtube',
        //   className: 'custom-menu__item_soc custom-menu__item_yt',
        //   linkAttr: {
        //     href: 'https://www.youtube.com/channel/UC5vsg5-xOIT0N-jilqFSz_w',
        //     target: '_blank',
        //   },
        // },
      ],
      buttons: [
        {
          isVolume: true,
          className: `custom-menu__volume button_volume-header ${
            store !== stores.ru ? 'volume_kz' : 'volume_ru'
          } _desktop`,
          icons: {
            on: 'buttons/volume-m-on',
            off: 'buttons/volume-m-off',
          },
          text: {
            on: 'header.menuList.buttons.sound.on',
            off: 'header.menuList.buttons.sound.off',
          },
        },
        {
          isLang: true,
          className: 'custom-menu__lang button_select-lang-button-header _desktop',
          /* icons: {
            on: "buttons/volume-m-on",
            off: "buttons/volume-m-off",
          },
          text: {
            on: "header.menuList.buttons.sound.on",
            off: "header.menuList.buttons.sound.off",
          }, */
        },
        ...(defaultContur === conturs.me
          ? [
              {
                isCountry: true,
                className: 'custom-menu__country button_select-country-button-header _desktop',
              },
            ]
          : []),
        {
          isMobileApp: true,
          text: 'header.menuList.buttons.mobileApp',
          className: 'custom-menu__button custom-button_purple custom-menu__button_mobile',
          attr: {
            link: 'header.menuList.buttons.mobileAppAttr.href',
          },
        },
        {
          isMobileApp: true,
          iconD: 'header/top/app',
          icon: 'header/top/app',
          text: 'header.menuList.buttons.downloadApp',
          className: 'custom-menu__button custom-menu__button_app custom-menu__button_desktop',
          attr: {
            tag: 'a',
            href: 'header.menuList.buttons.downloadAppAttr.href',
            target: '_blank',
          },
        },
        defaultContur === conturs.me
          ? {
              text: 'header.menuList.buttons.whatsappSupport',
              iconD: 'header/top/whatsapp',
              icon: 'header/top/whatsapp',
              className: 'custom-menu__button custom-menu__button_whatsapp',
              attr: {
                tag: 'a',
                href: supportLink,
                target: '_blank',
              },
            }
          : {
              text: 'header.menuList.buttons.telegramSupport.withoutTelegram',
              iconD: 'header/top/tg',
              icon: 'tg',
              className: 'custom-menu__button custom-menu__button_tg',
              attr: {
                tag: 'a',
                href: 'https://t.me/GoldappleSupportBot?start=gift',
                target: '_blank',
              },
            },
      ],
    },
    copyright: 'header.copyright',
    aromaButton: {
      img: image('/chan.png'),
      attr: {
        className:
          'button_no-bg button_icon button_transparent custom-header__button custom-header__button_aroma',
      },
    },
  }
}

// Экспортируем функцию для получения header с учетом store
export const getHeader = (store = defaultStore) => _getHeader(store)

export const authModalContent = {
  list: (t) => [
    {
      title: t('auth.modal.title'),
      text: t('auth.modal.text'),
      get sign() {
        const href = defContent('https://goldapple.ru/documents#privacy-policy')
        return t('auth.modal.sign', { href })
      },
      form: [
        {
          input: {
            placeholder: t('auth.modal.form.phone.placeholder'),
            type: 'tel',
            inputMode: 'numeric',
            rules: checkPhone('phone'),
            name: 'phone',
            autoFocus: true,
            autoComplete: 'tel',
            mask: defContent({
              ru: '+7(9**)***-**-**',
              kz: '+7(7**)***-**-**',
            }),
            alwaysShowMask: true,
            clearMaskOnLostFocus: false,
            formatChars: {
              '*': '[0-9]',
            },
          },
          sign: t('auth.modal.form.phone.sign'),
        },
      ],
      button: {
        text: t('auth.modal.button'),
        type: 'submit',
        callback: 'login',
        className: 'auth__item-button',
      },
    },
    {
      title: t('auth.modal.smsTitle'),
      text: t('auth.modal.smsText'),
      back: true,
      form: [
        {
          input: {
            type: 'code',
            name: 'code',
            inputMode: 'numeric',
            autoFocus: false,
            autoComplete: 'one-time-code',
            placeholder: '',
            count: 4,
            max: 4,
          },
          sign: t('auth.modal.form.phone.sign'),
        },
      ],
      send: {
        className: 'auth__item-send button_transparent button_send',
        callback: 'loginReload',
        text: t('auth.modal.resendCode'),
      },
      time: '03:23',
      button: {
        type: 'submit',
        text: t('auth.modal.button'),
        callback: 'login',
        className: 'auth__item-button',
      },
    },
    {
      back: true,
      title: t('auth.modal.registration.title'),
      info: t('auth.modal.registration.info'),
      form: [
        {
          input: {
            type: 'auth',
            placeholder: t('auth.modal.registration.firstName'),
            autoFocus: false,
            autoComplete: 'given-name',
            rules: username('firstName'),
            name: 'firstName',
            defaultValue: 'Герой',
          },
        },
        // {
        //   input: {
        //     type: "auth",
        //     placeholder: "Фамилия*",
        //     autoComplete: "family-name",
        //     rules: username("lastName"),
        //     name: "lastName",
        //   }
        // },
        {
          input: {
            type: 'auth',
            autoComplete: 'bday',
            inputMode: 'numeric',
            name: 'birthDate',
            mask: '99.99.9999',
            rules: birthDate('birthDate'),
            placeholder: t('auth.modal.registration.birthDate'),
            defaultValue: '12.12.2004',
          },
        },
        {
          input: {
            type: 'auth',
            autoComplete: 'email',
            placeholder: t('auth.modal.registration.email'),
            name: 'email',
            rules: email('email'),
            defaultValue: 'w@mail.ru',
          },
        },
        {
          radio: [
            {
              text: t('auth.modal.registration.gender.male'),
              name: 'sex',
              value: 'M',
              type: 'radio',
              rules: required('authCheckbox'),
            },
            {
              text: t('auth.modal.registration.gender.female'),
              name: 'sex',
              value: 'F',
              type: 'radio',
              rules: required('authCheckbox'),
            },
          ],
        },
      ],
      checkbox: [
        {
          label: t('auth.modal.registration.agreements.terms'),
          name: 'personalAgreement',
          rules: required('personalAgreement'),
        },
        {
          label: t('auth.modal.registration.agreements.communication'),
          name: 'communicationAgreement',
          //rules: required("communicationAgreement")
        },
      ],
      button: {
        text: t('auth.modal.registration.button'),
        type: 'submit',
        callback: 'signup',
        className: 'auth__item-button',
      },
    },
  ],
}

export const preloaderContent = {
  logo: {
    icon: 'logo_ga',
  },
  note: 'preloader.note',
}

export const errorContent = {
  title: 'error.title',
  text: 'error.text',
  button: {
    text: 'error.button',
    className: 'error__button custom-button_yellow custom-button_error',
  },
}

export const startInfo = {
  title: 'start.title',
  text: 'start.text',
  button: {
    tag: 'button',
    text: 'start.button',
  },
}

export const stubContent = {
  logo: {
    href: '#',
    icon: 'logoD',
  },
  text: 'stub.text',
  special: {
    title: 'stub.special.title',
    text: 'stub.special.text',
  },
  new_season: {
    title: 'stub.new_season.title',
    text: 'stub.new_season.text',
  },
  button: {
    text: 'stub.button',
    className: 'stub__button',
  },
  copyright: 'stub.copyright',
}

export const startContent = {
  logo: {
    href: '#',
    icon: 'logoD',
  },
  title: defaultContur === conturs.me ? 'startContent.meTitle' : 'startContent.title',
  button: {
    icons: {
      on: 'buttons/volume-m-on',
      off: 'buttons/volume-m-off',
    },
    text: {
      on: 'startContent.button.text.on',
      off: 'startContent.button.text.off',
    },
  },
  note: 'startContent.note',
}

export const info = {
  title: 'info.title',
  img: defContent(image('shake/1.png')),
  text: 'info.text',
  button: {
    text: 'info.button.text',
    className: 'info__button custom-button_show-anim',
  },
}

export const creating = {
  title: 'creating.title',
  image: image('main/elf.png'),
  form: (t) => [
    {
      input: {
        type: 'confirmation',
        placeholder: t('creating.form.placeholder'),
        autoFocus: false,
        readOnly: true,
        autoComplete: 'perfume-name',
        name: 'perfume-name',
      },
      sign: t('creating.form.sign'),
    },
  ],
  button: {
    text: 'creating.button.text',
  },
  generateButton: {
    text: 'creating.generateButton.text',
  },
}

export const scrollbarSettings = {
  width: '100%',
  height: '100%',
  noScrollX: true,
  removeTracksWhenNotUsed: true,
}

export const compilationScrollbarSettings = {
  ...scrollbarSettings,
  trackYProps: {
    style: {
      right: 0,
      width: 5,
      background: '#F1F1F1',
    },
  },
  thumbYProps: {
    style: {
      background: '#7D54DE',
    },
  },
}

export const prizeModalScrollSettings = {
  ...scrollbarSettings,
  trackYProps: {
    style: {
      width: 0,
      background: 'transparent',
      // right: -10
    },
  },
  thumbYProps: {
    style: {
      background: 'transparent',
    },
  },
}

export const taskScrollSettings = {
  width: '100%',
  height: '100%',
  noScrollY: true,
  removeTracksWhenNotUsed: true,
  trackXProps: {
    style: {
      width: 0,
      background: 'transparent',
      // right: -10
    },
  },
}

export const ratingScrollbarSettings = {
  ...scrollbarSettings,
  trackYProps: {
    style: {
      width: 0,
      background: 'transparent',
    },
  },
}

export const customizationScrollbarSettings = {
  ...scrollbarSettings,
  wrapperProps: {
    style: {
      inset: 0,
    },
  },
  trackYProps: {
    style: {
      width: 0,
      background: 'transparent',
      // right: -10
    },
  },
  thumbYProps: {
    style: {
      background: 'transparent',
    },
  },
}

export const rulesContent = {
  list: (t) => [
    {
      img: 'rules/1.png',
      type: 'old',
      text: 'rulesContent.list.first.text',
      buttonText: t('rulesContent.list.first.buttonText'),
    },
    {
      img: defaultContur === conturs.me ? 'rules/me/2.png' : 'rules/2.png',
      type: 'old',
      text: 'rulesContent.list.second.text',
      buttonText: t('rulesContent.list.second.buttonText'),
    },
    {
      picture: {
        sourceData: {
          sources: [
            {
              srcSet: image('rules/friday/1-m.webp'),
              type: '/image/webp',
              media: '(max-width:1023px)',
            },
            {
              srcSet: image('rules/friday/1-m.jpg'),
              media: '(max-width:1023px)',
            },
            {
              srcSet: image('rules/friday/1.webp'),
              type: 'image/webp',
            },
          ],
        },
        imgAttr: {
          src: image('rules/friday/1.jpg'),
        },
      },
      event: BLACK_FRIDAY,
      type: 'height',
      modType: 'black-friday',
      text: 'rulesFridayContent.list.0.text',
      buttonText: t('other.toGame'),
    },
  ],
  button: {
    text: 'rulesContent.button.text',
    text2: 'rulesContent.button.text2',
  },
}

export const gamesList = {
  title: 'gamesList.title',
  requestTimeout: 5000,
  close: 'gamesList.close',
  info: [
    {
      icon: 'coin-g',
      field: 'money',
    },
    {
      icon: 'energy-g',
      field: 'attempts',
    },
  ],
  toggle: {
    className: 'games__toggle',
    tutorId: 'game-toggle',
    list: [
      {
        text: 'gamesList.toggle.list.games',
        action: 'games',
      },
      {
        text: 'gamesList.toggle.list.rating',
        action: 'rating',
      },
    ],
  },
  list: {
    runner: {
      image: platformPreviewImage,
      imageM: platformPreviewImage,
      imageAlfa: isAlfaGameActive() ? image('games/preview/beautypad-alfa-2.jpg') : null,
      imageBourjois: isPlatformBourjoisAssets()
        ? image('games/preview/beautypad-bourjois-2.png')
        : null,
      prev: platformPreviewImage,
      title: 'gamesList.list.runner.title',
      isRating: true,
      apiName: 'Runner',
      text: 'gamesList.list.runner.text',
      game: 'platform',
      isVisibleInfo: false,
    },
    jumper: {
      className: 'games__item_black',
      image: jumperPreviewImage,
      imageM: jumperPreviewImage,
      prev: jumperPreviewImage,
      title: 'gamesList.list.jumper.title',
      isRating: true,
      apiName: 'Jumper',
      text: 'gamesList.list.jumper.text',
      game: 'jumper',
      isVisibleInfo: false,
    },
    match3: {
      image:
        defaultStore === stores.ae
          ? image('games/preview/me/match3.png')
          : image('games/preview/match3.png'),
      imageM:
        defaultStore === stores.ae
          ? image('games/preview/me/match3.png')
          : image('games/preview/match3.png'),
      prev:
        defaultStore === stores.ae
          ? image('games/preview/me/match3.png')
          : image('games/preview/match3.png'),
      title: 'gamesList.list.match3.title',
      isRating: false,
      apiName: 'Match3',
      text: 'gamesList.list.match3.text',
      game: 'match3',
      isVisibleInfo: true,
    },
    memories: {
      image: image('games/preview/memories.png'),
      imageM: image('games/preview/memories.png'),
      imageT: image('games/preview/memories.png'),
      prev: image('games/preview/memories.png'),
      title: 'gamesList.list.memories.title',
      isRating: false,
      apiName: 'Memories',
      text: 'gamesList.list.memories.text',
      game: 'memories',
      isVisibleInfo: true,
    },
  },
}

export const gameRating = {
  ratingCount: 50,
  box: {
    date: 'gameRating.box.date',
    text: 'gameRating.box.text',
    image: image('games/box.png'),
    button: {
      text: 'gameRating.box.button.text',
      className: 'games__rating-box-button custom-button_games-rating',
    },
    toggle: {
      className: 'game-rating__toggle',
      list: [
        {
          text: 'gameRating.box.toggle.list.current',
          action: 'current',
        },
        {
          text: 'gameRating.box.toggle.list.previous',
          action: 'old',
        },
      ],
    },
  },
}

export const gamesTutorial = {
  platform: {
    title: 'gamesTutorial.platform.title',
    image: platformPreviewImage,
    text: 'gamesTutorial.platform.text',
    buttonText: 'gamesTutorial.platform.button.text',
  },
  jumper: {
    title: 'gamesTutorial.jumper.title',
    image: jumperPreviewImage,
    text: 'gamesTutorial.jumper.text',
    buttonText: 'gamesTutorial.jumper.button.text',
  },
  match3: {
    title: 'gamesTutorial.match3.title',
    image:
      defaultStore === stores.ae
        ? image('games/preview/me/match3.png')
        : image('games/preview/match3.png'),
    text: 'gamesTutorial.match3.text',
    buttonText: 'gamesTutorial.match3.button.text',
  },
  memories: {
    title: 'gamesTutorial.memories.title',
    image: image('games/preview/memories.png'),
    text: 'gamesTutorial.memories.text',
    buttonText: 'gamesTutorial.memories.button.text',
  },
}

export const productContent = {
  subtitle: 'productContent.subtitle',
  promocode: 'ALCR8JWGSX9UI',
  hp: XP,
  promoCodeText: 'productContent.promoCodeText',
  copyPromocode: 'productContent.copyPromocode',
  copiedPromocode: 'productContent.copiedPromocode',
  link: {
    text: 'productContent.link.text',
    href: baseUrl('docs/Правила_проведения.pdf'),
  },
  moreTitle: 'productContent.moreTitle',
  buttons: [
    {
      text: 'productContent.buttons.buy',
      gtm: 'GTMBuyBtn',
      attr: {
        tag: 'a',
        target: '_blank',
        className:
          'custom-button quiz-win-modal__button quiz-win-modal__button_buy custom-button_show-anim',
      },
    },
    {
      text: 'productContent.buttons.backToGame',
      gtm: 'GTMQuizBackToGame',
      attr: {
        className:
          'custom-button custom-button_white quiz-win-modal__button quiz-win-modal__button_share',
      },
    },
  ],
  product: {
    name: 'productContent.product.name',
    image: {
      path: '',
      fileName: '',
    },
    code: 'GA3456X',
    list: [],
  },
  selection: { title: 'productContent.selection.title' },
}

export const navigationContent = {
  buttons: [
    {
      attr: {
        className:
          'navigation__button button_navigation button_icon button_transparent custom-button_navigation',
      },
      icon: 'buttons/navigation/main',
      action: 'main',
      text: 'navigationContent.buttons.0.text',
    },
    {
      attr: {
        className:
          'navigation__button button_navigation button_icon button_transparent custom-button_navigation',
      },
      icon: 'buttons/navigation/games',
      action: 'games',
      gtm: 'GTMGames',
      type: 'games',
      tutorId: 'mini-games-button',
      text: 'navigationContent.buttons.1.text',
      onboardingStep: ONBOARDING_STEPS_TYPES.GAMES,
    },
    {
      attr: {
        className:
          'navigation__button button_navigation button_icon button_transparent custom-button_navigation',
      },
      icon: 'buttons/navigation/custom',
      action: 'customization',
      gtm: 'GTMCustomization',
      type: 'customization',
      tutorId: 'customization',
      text: 'navigationContent.buttons.2.text',
      onboardingStep: ONBOARDING_STEPS_TYPES.CUSTOMIZATION,
    },
    {
      attr: {
        className:
          'navigation__button button_navigation button_icon button_transparent custom-button_navigation',
      },
      icon: 'buttons/navigation/challenge',
      action: 'challenges',
      type: 'challenges',
      text: 'navigationContent.buttons.3.text',
      onboardingStep: ONBOARDING_STEPS_TYPES.CHALLENGES,
      gtm: 'GTMChallenges',
    },
    {
      attr: {
        className:
          'navigation__button button_navigation button_icon button_transparent custom-button_navigation',
      },
      icon: 'buttons/navigation/rating',
      action: 'rating',
      gtm: 'GTMPrizes',
      text: 'navigationContent.buttons.3.text',
      onboardingStep: ONBOARDING_STEPS_TYPES.RATING,
    },
  ],
}

export const statusPanel = {
  icons: {
    games: [
      {
        i: '0',
        icon: 'main/coin',
        name: 'coin',
        title: 'statusPanel.icons.0.title',
        description: 'statusPanel.icons.0.description',
      },
      {
        i: '1',
        icon: 'main/energy',
        name: 'energy',
        title: 'statusPanel.icons.1.title',
        description: 'statusPanel.icons.1.description',
        clickableIcon: 'main/energy-clickable',
      },
    ],
    main: [
      {
        i: '0',
        icon: 'main/coin',
        name: 'coin',
        title: 'statusPanel.icons.0.title',
        description: 'statusPanel.icons.0.description',
      },
      {
        i: '1',
        icon: 'main/energy',
        name: 'energy',
        title: 'statusPanel.icons.1.title',
        description: 'statusPanel.icons.1.description',
        clickableIcon: 'main/energy-clickable',
      },
      {
        i: '13',
        icon: 'main/likes',
        name: 'likes',
        title: 'statusPanel.icons.13.title',
        description: 'statusPanel.icons.13.description',
      },
      {
        i: '2',
        icon: 'main/beauties',
        name: 'beauties',
        title: 'statusPanel.icons.2.title',
        description: 'statusPanel.icons.2.description',
      },
      {
        i: '3',
        icon: 'main/gifts-white',
        name: 'gacha_event_cash',
        title: 'statusPanel.icons.3.title',
        description: 'statusPanel.icons.3.description',
      },
    ],
    shop: [
      {
        icon: 'main/coin',
        name: 'coin',
      },
      {
        icon: 'shop/shop-coin',
        name: 'charm',
        clickableIcon: 'main/charm-clickable',
      },
    ],
    customization: [
      {
        i: '0',
        icon: 'main/coin',
        name: 'coin',
        title: 'statusPanel.icons.0.title',
        description: 'statusPanel.icons.0.description',
      },
      {
        i: '2',
        icon: 'main/beauties',
        name: 'beauties',
        title: 'statusPanel.icons.2.title',
        description: 'statusPanel.icons.2.description',
      },
      {
        i: '3',
        icon: 'main/gifts-white',
        name: 'gacha_event_cash',
        title: 'statusPanel.icons.3.title',
        description: 'statusPanel.icons.3.description',
      },
    ],
    ['gift-choose']: [
      {
        i: '0',
        icon: 'main/coin',
        name: 'coin',
        title: 'statusPanel.icons.0.title',
        description: 'statusPanel.icons.0.description',
      },
      {
        i: '1',
        icon: 'gifts',
        name: 'charm',
      },
    ],
  },
  namesLinks: {
    coin: 'money',
    energy: 'attempts',
    charm: 'gacha_event_cash',
    beauties: 'beauties',
    gacha_event_cash: 'gacha_event_cash',
  },
}

export const mainContent = {
  header: {
    namesLinks: {
      coin: 'money',
      energy: 'attempts',
    },
    button: {
      action: 'help',
      attr: {
        icon: 'main/help',
        className: 'main__help button_help',
      },
    },
  },
  reactions: {
    1: 'main/heart-icon',
    2: 'main/cool-icon',
    3: 'main/fire-icon',
    4: 'main/like-icon',
  },
  bathroom: {
    attr: {
      className: 'button_bathroom',
      gtm: 'GTMShop',
      disposable: true,
    },
  },
  interactiveShop: {
    attr: {
      className: 'button_bathroom',
      disposable: true,
    },
    newFlagData: 'interactiveShop',
  },
  bottom: {
    bathroom: [
      {
        attr: {
          className: 'main__bath-action main__bath-action_0 button_bath',
        },
        icon: 'buttons/soap',
        action: 'soap',
      },
      {
        attr: {
          className: 'main__bath-action main__bath-action_1 button_bath',
        },
        icon: 'buttons/brush',
        action: 'brush',
      },
      {
        attr: {
          className: 'main__bath-action main__bath-action_2 button_bath',
        },
        icon: 'buttons/shower',
        action: 'shower',
      },
    ],
    buttons: [
      {
        attr: {
          className: 'main__tasks button_main-nav button_icon button_transparent',
        },
        icon: 'buttons/task-new',
        action: 'seasonTask',
        gtm: 'GTMQuiz',
        newType: 'task',
      },
      {
        attr: {
          className: 'main__gifts button_main-nav button_icon button_transparent',
        },
        icon: defaultContur === conturs.me ? 'buttons/present' : 'buttons/sales-nav',
        action: 'gifts',
        gtm: 'GTMGifts',
        type: 'gifts',
        newType: 'task',
      },
      {
        attr: {
          className: 'main__box button_main-nav button_icon button_transparent',
        },
        icon: 'buttons/box',
        action: 'box',
        gtm: 'GTMBoxes',
        newType: 'box',
      },
    ],
  },
}

export const taskContent = {
  title: 'task.title',
  premiumOffer: {
    text: 'task.premiumOffer.text',
    description: 'task.premiumOffer.description',
  },
  filterList: [
    { text: 'task.filterList.0.text', action: 'daily' },
    { text: 'task.filterList.1.text', action: 'weekly' },
    { text: 'task.filterList.2.text', action: 'others' },
    { text: 'task.filterList.3.text', action: 'special' },
  ],
  dailyTitle: 'task.dailyTitle',
  othersTitle: 'task.othersTitle',
  formattedTasksDefault: {
    daily: {
      title: 'task.dailyTitle',
      order: 0,
      list: [],
      completed: 0,
      fresh: 0,
    },
    weekly: {
      title: 'task.filterList.1.text',
      order: 1,
      list: [],
      completed: 0,
      fresh: 0,
    },
    others: {
      title: 'task.othersTitle',
      order: 2,
      list: [],
      completed: 0,
      fresh: 0,
    },
    special: {
      title: 'task.filterList.3.text',
      order: 3,
      list: [],
      completed: 0,
      fresh: 0,
    },
  },
  buttons: {
    subscribe: ({ href }) => ({
      text: 'task.buttons.subscribe',
      tag: 'a',
      target: '_blank',
      href,
    }),
    ticket: () => ({ text: 'task.buttons.ticket' }),
    complete: () => ({ text: 'task.buttons.complete' }),
    follow: () => ({ text: 'task.buttons.follow' }),
    answer: () => ({ text: 'task.buttons.answer' }),
    default: ({ uid }) => {
      const texts = {
        ...Object.keys(tasksForSavingProductsToGA).reduce(
          (acc, uid) => ({
            ...acc,
            [uid]: 'task.buttons.add',
          }),
          {},
        ),
        completedProfile: 'task.buttons.fillProfile',
        default: 'task.buttons.default',
      }
      return { text: texts[uid] ?? texts.default }
    },
    buy: ({ href }) => ({
      text: 'task.buttons.buy',
      tag: 'a',
      target: '_blank',
      href,
    }),
    goToComplete: ({ href }) => ({
      btnMod: 'goToComplete',
      text: 'task.buttons.goToComplete',
      tag: 'a',
      target: '_blank',
      href,
    }),
  },
  animationDelay: (index) => `${0.2 + index * 0.05}s`,
  selectionTitle: 'task.selectionTitle',
  buttonsList: [
    {
      className: 'task__button button_tasks button_pink',
      text: 'task.buttonsList.0.text',
    },
    {
      className: 'task__button button_tasks',
      text: 'task.buttonsList.1.text',
    },
  ],
  winners: {
    img: image('tasks/img.png'),
    title: 'task.winners.title',
    text: 'task.winners.text',
    button: {
      className: 'task__winners-button button_task-min button_pink',
      text: 'task.winners.button.text',
    },
  },
  tutorial: {
    img: image('tasks/gift.png'),
    list: [],
    button: {
      className: 'tutorial-modal__button button_pink',
      text: 'task.tutorial.button.text',
    },
  },
  premiumData: {
    withPass: 'task.premiumData.withPass',
  },
}

export const raffleContent = {
  baseTitle: 'raffle.baseTitle',
  winTitle: 'raffle.finish.winTitle',
  loseTitle: 'raffle.finish.loseTitle',
  questUID: 'raffle',
  filterList: [
    { text: 'raffle.filterList.0.text', action: 'about' },
    { text: 'raffle.filterList.1.text', action: 'tasks' },
  ],
  winners: 'raffle.winners',
  links: {
    qa: 'https://wa.me/97431190811',
    ae: 'https://wa.me/971527732032',
    sa: 'https://wa.me/966543639700',
  },
}

export const customizationContent = {
  toggle: [
    {
      icon: 'customization/clothes',
      text: 'customization.toggle.0.text',
      action: 'character',
    },
    {
      icon: 'customization/room',
      text: 'customization.toggle.1.text',
      action: 'room',
    },
    {
      icon: defaultContur === conturs.me ? 'customization/gifts' : 'beauties',
      text: 'customization.toggle.2.text',
      action: 'beauties',
    },
  ],
  newText: 'customization.newText',
  buyButtons: [
    {
      attr: {
        text: 'customization.buyButtons.0.text',
        className: 'buy-modal__button lose-modal__button custom-button_price',
        coins: 'main/coins',
      },
      action: 'buy',
    },
    {
      attr: {
        text: 'customization.buyButtons.1.text',
        className: 'buy-modal__button custom-button_gray lose-modal__button',
      },
      action: 'cancel',
    },
  ],
  cantBuyButtons: [
    {
      attr: {
        text: 'customization.cantBuyButtons.0.text',
        className: 'buy-modal__button lose-modal__button custom-button_price',
      },
      action: 'cancel',
    },
  ],
  beautiesSection: (t) => {
    return {
      room: {
        image:
          defaultContur === conturs.me
            ? image('customization/filters/gifts-room.png')
            : image('customization/filters/beauties-room.png'),
        title: t('customization.beauties.room'),
        system_name: 'room',
      },
      character: {
        image:
          defaultContur === conturs.me
            ? image('customization/filters/gifts-character.png')
            : image('customization/filters/beauties-character.png'),
        title: t('customization.beauties.character'),
        system_name: 'character',
      },
      shower: {
        image:
          defaultContur === conturs.me
            ? image('customization/filters/gifts-shower.png')
            : image('customization/filters/beauties-shower.png'),
        title: t('customization.beauties.shower'),
        system_name: 'shower',
      },
    }
  },
  buyBeautiesModalButtons: [
    {
      attr: {
        text: 'customization.buyBeautiesModal.buttons.0.text',
        className:
          'buy-modal__button buy-modal__button-beauties lose-modal__button custom-button_price',
      },
      action: 'buy',
    },
    {
      attr: {
        text: 'customization.buyBeautiesModal.buttons.1.text',
        className: 'buy-modal__button custom-button_gray lose-modal__button',
      },
      action: 'cancel',
    },
  ],
  buyGiftsModalButtons: [
    {
      attr: {
        text: 'customization.buyGiftsModal.buttons.0.text',
        className:
          'buy-modal__button buy-modal__button-gifts lose-modal__button custom-button_price',
      },
      action: 'buy',
    },
    {
      attr: {
        text: 'customization.buyGiftsModal.buttons.1.text',
        className: 'buy-modal__button custom-button_gray lose-modal__button',
      },
      action: 'cancel',
    },
  ],
}

export const rating = {
  state: 'rating',
  ratingCount: 100,
  title: {
    previous: 'rating.title.previous',
    new: 'rating.title.new',
  },
  subtitle: {
    previous: 'rating.subtitle.previous',
    new: 'rating.subtitle.new',
  },
  buttonText: 'rating.buttonText',
  text: {
    previous: 'rating.text.previous',
    new: 'rating.text.new',
  },
  month: 'rating.month',
  date: {
    week: {
      previous: 'rating.date.week.previous',
      new: 'rating.date.week.new',
    },
    month: 'rating.date.month',
  },
  // week: "rating.week",
  toggleData: {
    list: [
      {
        text: `rating.toggleData.list.0.text`,
        action: 'week',
      },
      {
        text: 'rating.toggleData.list.1.text',
        action: 'month',
      },
    ],
    settings: {
      width: [50, 50],
    },
  },
  ratingPromises: [
    {
      address: 'requestsGameGetRating',
      field: 'rating',
      key: 'ratingMonth',
      type: 'month',
    },
    {
      address: 'requestsGameGetWeekRating',
      field: ['rating', 'startDate', 'endDate'],
      key: 'ratingWeek',
      type: 'week',
    },
    {
      address: 'requestsGameUserRating',
      field: 'user',
      key: 'ratingUserMonth',
      type: 'month',
    },
    {
      address: 'requestsGameUserWeekRating',
      field: 'user',
      key: 'ratingUserWeek',
      type: 'week',
    },
  ],
  countDownText: 'rating.countDown',
  reward: (t) => ({
    firstPlace: t('rating.reward.firstPlace'),
    secondToFifthPlace: t('rating.reward.secondToFifthPlace'),
    sixthToTenthPlace: t('rating.reward.sixthToTenthPlace'),
    eleventhToTwentiethPlace: t('rating.reward.eleventhToTwentiethPlace'),
  }),
}

//тест
export const oldRating = {
  state: 'rating',
  title: 'oldRating.title',
  text: 'oldRating.text',
  months: {
    1: 'oldRating.months.1',
    2: 'oldRating.months.2',
    3: 'oldRating.months.3',
    4: 'oldRating.months.4',
    5: 'oldRating.months.5',
    6: 'oldRating.months.6',
    7: 'oldRating.months.7',
    8: 'oldRating.months.8',
    9: 'oldRating.months.9',
    10: 'oldRating.months.10',
    11: 'oldRating.months.11',
    12: 'oldRating.months.12',
  },
  week: 'oldRating.week',
  toggleData: {
    list: [
      {
        text: `oldRating.toggleData.list.0.text`,
        action: 'week',
      },
      {
        text: 'oldRating.toggleData.list.1.text',
        action: 'month',
      },
    ],
    settings: {
      width: [50, 50],
    },
  },
  ratingPromises: [
    { address: 'requestsGameGetRating', field: 'rating', key: 'ratingMonth' },
    {
      address: 'requestsGameGetWeekRating',
      field: ['rating', 'startDate', 'endDate'],
      key: 'ratingWeek',
    },
    { address: 'requestsGameUserRating', field: 'user', key: 'ratingUserMonth' },
    { address: 'requestsGameUserWeekRating', field: 'user', key: 'ratingUserWeek' },
    { address: 'requestsGameOldWeekRating', field: 'rating', key: 'ratingWeek' },
  ],
}

export const prizes = {
  title: 'prizes.title',
  list: [],
}

export const gifts = {
  title: 'gifts.title',
  subTitle: 'gifts.subTitle',
  modalButtons: [
    {
      className:
        'win-modal__button button_win custom-button quiz-win-modal__button quiz-win-modal__button_buy custom-button_show-anim',
      text: 'gifts.modalButtons.0.text',
      tag: 'a',
      target: '_blank',
    },
    {
      className: 'win-modal__button custom-button_gray-d',
      text: 'gifts.modalButtons.1.text',
    },
  ],
  modalLink: { href: '', text: 'gifts.modalLink.text' },
  myStub: {
    title: 'gifts.myStub.title',
    text: 'gifts.myStub.text',
  },
  stub: {
    title: 'gifts.stub.title',
    text: 'gifts.stub.text',
  },
}

export const addFriend = {
  form: [
    {
      input: {
        type: 'id',
        placeholder: 'addFriend.form.0.input.placeholder',
        autoFocus: false,
        autoComplete: 'friend-id',
        name: 'friendId',
        rules: (t) => checkId(t),
      },
    },
  ],
  friend: {
    name: 'addFriend.friend.name',
    level: 'addFriend.friend.level',
    points: 'addFriend.friend.points',
  },
  button: {
    text: 'addFriend.button.text',
    type: 'submit',
    callback: 'addfriend',
    className: 'custom-button add-friend-modal__button add-friend-modal__button_add',
  },
}

export const buyModalContent = {
  text: 'buyModal.text',
  gamesText: 'buyModal.gamesText',
  premium: {
    title: 'buyModal.premium.title',
  },
  hp: {
    title: XP,
    text: 'buyModal.hp.text',
  },
  buttons: {
    fromBeauty: [
      {
        attr: {
          text: 'buyModal.buttons.fromBeauty.0.text',
          className: 'buy-modal__button lose-modal__button',
        },
        to: 'task',
        action: 'cancel',
      },
      {
        attr: {
          text: 'buyModal.buttons.fromBeauty.1.text',
          className: 'buy-modal__button custom-button_gray lose-modal__button',
        },
        to: 'main',
        action: 'cancel',
      },
    ],
    fromGames: [
      {
        attr: {
          text: 'buyModal.buttons.fromGames.0.text',
          className: 'buy-modal__button lose-modal__button',
        },
        to: 'task',
        action: 'cancel',
      },
      {
        attr: {
          text: 'buyModal.buttons.fromGames.1.text',
          className: 'buy-modal__button custom-button_gray lose-modal__button',
        },
        to: 'main',
        action: 'cancel',
      },
    ],
    buy: [
      {
        attr: {
          text: 'buyModal.buttons.buy.0.text',
          className: 'buy-modal__button lose-modal__button custom-button_price',
          coins: 'main/coins',
        },
        count: true,
        action: 'buy',
      },
      {
        attr: {
          text: 'buyModal.buttons.buy.1.text',
          className: 'buy-modal__button custom-button_gray lose-modal__button',
        },
        action: 'cancel',
      },
    ],
    buyPrize: [
      {
        attr: {
          text: 'buyModal.buttons.buyPrize.0.text',
          className: 'buy-modal__button lose-modal__button custom-button_price',
        },
        count: false,
        action: 'buy',
      },
      {
        attr: {
          text: 'buyModal.buttons.buyPrize.1.text',
          className: 'buy-modal__button custom-button_gray lose-modal__button',
        },
        action: 'cancel',
      },
    ],
    fromLootBox: [
      {
        action: 'buy',
        attr: {
          text: 'buyModal.buttons.fromLootBox.0.text',
          className: 'buy-modal__button lose-modal__button custom-button_price',
        },
      },
      {
        attr: {
          text: 'buyModal.buttons.fromLootBox.1.text',
          className: 'buy-modal__button custom-button_gray lose-modal__button',
        },
        action: 'cancel',
      },
    ],
    cancel: [
      {
        attr: {
          text: 'buyModal.buttons.cancel.0.text',
          className: 'buy-modal__button lose-modal__button',
        },
        action: 'cancel',
      },
    ],
  },
  titleBuy: (item) => safeHTML(`Ты покупаешь \n ${item.title}?`),
  titleCanceled: (fromGames) => safeHTML(`Не хватает ${fromGames ? 'энергии' : 'бьюти-коинов'}`),
}

export const buyPrizeModalContent = {
  buttons: [
    {
      attr: {
        text: 'buyPrizeModalContent.buttons.0.attr.text',
        className: 'buy-modal__button lose-modal__button',
      },
      action: 'buy',
    },
    {
      attr: {
        text: 'buyPrizeModalContent.buttons.1.attr.text',
        className: 'buy-modal__button custom-button_gray lose-modal__button',
      },
      action: 'cancel',
    },
  ],
}

export const resourceContent = {
  title: 'resourceContent.title',
  text: 'resourceContent.text',
  button: {
    text: 'resourceContent.button.text',
    className: 'resource-modal__button',
  },
}

export const wordModalPlaceholders = {
  word: 'wordModalPlaceholders.word',
  number: 'wordModalPlaceholders.number',
}

export const wordModalContent = {
  titleIsWord: 'wordModalContent.titleIsWord',
  titleIsNumber: 'wordModalContent.titleIsNumber',
  text: 'wordModalContent.text',
  button: {
    text: 'wordModalContent.button.text',
  },
  form: (t) => [
    {
      input: {
        type: 'id',
        placeholder: t('wordModalPlaceholders.word'),
        autoFocus: false,
        autoComplete: 'friend-id',
        rules: checkWord(),
        name: 'friendId',
      },
    },
  ],
}

export const promocodeContent = {
  conditions: 'promocodeContent.conditions',
}

export const gameWinModalContent = {
  mod: 'task',
  title: 'gameWinModalContent.title',
  img: image('win/img1.png'),
  note: 'gameWinModalContent.note',
  promocode: 'ALCR8JWGSX9UI',
  copyPromocode: 'gameWinModalContent.copyPromocode',
  copiedPromocode: 'gameWinModalContent.copiedPromocode',
  list: [
    'gameWinModalContent.list.0',
    'gameWinModalContent.list.1',
    'gameWinModalContent.list.2',
    'gameWinModalContent.list.3',
  ],
  salary: '+10',
  link: {
    text: 'gameWinModalContent.link.text',
    href: baseUrl('docs/Правила_проведения.pdf'),
  },
  buttons: [
    {
      text: 'gameWinModalContent.buttons.0.text',
      tag: 'a',
      target: '_blank',
      className:
        'custom-button procedure-result-modal__button procedure-result-modal__button_buy win-modal__button custom-button_show-anim',
    },
    {
      text: 'gameWinModalContent.buttons.1.text',
      className:
        'custom-button custom-button_gray procedure-result-modal__button procedure-result-modal__button_share win-modal__button',
    },
  ],
  selection: {
    title: 'gameWinModalContent.selection.title',
    list: [],
  },
}

export const bathroomBg = {
  sourceData: {
    sources: [
      {
        srcSet: '/images/room/bathroom.webp',
        type: 'image/webp',
      },
      {
        srcSet: '/images/room/bathroom.jpg',
      },
    ],
  },
  imgAttr: {
    className: 'room__bathroom-background',
    src: '/images/room/bathroom.jpg',
    alt: 'bathroomBg.imgAttr.alt',
  },
}

export const bathroomBgBlur = {
  sourceData: {
    sources: [
      {
        srcSet: '/images/room/bathroom.webp',
        type: 'image/webp',
      },
      {
        srcSet: '/images/room/bathroom.jpg',
      },
    ],
  },
  imgAttr: {
    className: 'room__bathroom-background-blur',
    src: '/images/room/bathroom.jpg',
    alt: 'bathroomBgBlur.imgAttr.alt',
  },
}

export const faqContent = {
  title: 'faq.title',
  list: [
    {
      question: 'faq.list.0.question',
      answer: 'faq.list.0.answer',
    },
    {
      question: 'faq.list.1.question',
      answer: 'faq.list.1.answer',
    },
    {
      question: 'faq.list.2.question',
      answer: 'faq.list.2.answer',
    },
    {
      question: 'faq.list.3.question',
      answer: 'faq.list.3.answer',
    },
    {
      question: 'faq.list.4.question',
      answer: 'faq.list.4.answer',
    },
    {
      question: 'faq.list.5.question',
      answer: 'faq.list.5.answer',
    },
    {
      question: 'faq.list.6.question',
      answer: 'faq.list.6.answer',
    },
    {
      question: 'faq.list.7.question',
      answer: 'faq.list.7.answer',
    },
  ],
  copyright: 'faq.copyright',
}

export const prizeAboutModalContent = {
  className: 'about-modal_prize',
  img: 'about/1000.png',
  title: 'prizeAboutModalContent.title',
  description: 'prizeAboutModalContent.description',
  buttons: {
    enterModal: [
      {
        text: 'prizeAboutModalContent.buttons.enterModal.0.text',
        className: 'custom-button_yellow',
      },
    ],
    prizeModal: [
      {
        text: 'prizeAboutModalContent.buttons.prizeModal.0.text',
        className: 'custom-button_yellow',
        callback: 'setState',
        callbackOptions: 'gifts',
        closeAll: true,
      },
      {
        text: 'prizeAboutModalContent.buttons.prizeModal.1.text',
        className: 'custom-button_gray',
      },
    ],
  },
  prizes: [
    {
      description: 'prizeAboutModalContent.prizes.0.description',
      reward_bonuses: 1000,
      title: 'prizeAboutModalContent.prizes.0.title',
      type: 'WeekBonusScore',
      image: image('prizes/bonus_1000.png'),
    },
    {
      description: 'prizeAboutModalContent.prizes.0.description',
      reward_bonuses: 1000,
      title: 'prizeAboutModalContent.prizes.0.title',
      type: 'WeekBonusScore',
      image: image('prizes/bonus_1000.png'),
    },
    {
      description: 'prizeAboutModalContent.prizes.0.description',
      reward_bonuses: 1000,
      title: 'prizeAboutModalContent.prizes.0.title',
      type: 'WeekBonusScore',
      image: image('prizes/bonus_1000.png'),
    },
    {
      description: 'prizeAboutModalContent.prizes.0.description',
      reward_bonuses: 1000,
      title: 'prizeAboutModalContent.prizes.0.title',
      type: 'WeekBonusScore',
      image: image('prizes/bonus_1000.png'),
    },
    {
      description: 'prizeAboutModalContent.prizes.0.description',
      reward_bonuses: 1000,
      title: 'prizeAboutModalContent.prizes.0.title',
      type: 'WeekBonusScore',
      image: image('prizes/bonus_1000.png'),
    },
  ],
}

export const prizeMonthAboutModalContent = {
  className: 'about-modal_prize',
  img: 'about/2000.png',
  title: 'prizeMonthAboutModalContent.title',
  description: 'prizeMonthAboutModalContent.description',
  buttons: {
    enterModal: [
      {
        text: 'prizeMonthAboutModalContent.buttons.enterModal.0.text',
        className: 'custom-button_yellow',
      },
    ],
    prizeModal: [
      {
        text: 'prizeMonthAboutModalContent.buttons.prizeModal.0.text',
        className: 'custom-button_yellow',
        callback: 'setState',
        callbackOptions: 'gifts',
        closeAll: true,
      },
      {
        text: 'prizeMonthAboutModalContent.buttons.prizeModal.1.text',
        className: 'custom-button_gray',
      },
    ],
  },
  prizes: [
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description: 'prizeMonthAboutModalContent.prizes.0.description',
      reward_bonuses: 2000,
      title: 'prizeMonthAboutModalContent.prizes.0.title',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
    {
      description:
        '<p><strong>2000 бонусов.</strong> Бонусы придут на карту клиента Золотого Яблока <strong>в течение 7 дней</strong>. Ими можно оплатить полную стоимость покупки.&nbsp;</p>',
      reward_bonuses: 2000,
      title: 'Бонусы',
      type: 'BonusScore',
      image: image('prizes/bonus_2000.png'),
    },
  ],
}

export const inactiveGameModalContent = {
  className: 'about-modal_inactive',
  title: 'inactiveGameModalContent.title',
  text: 'inactiveGameModalContent.text',
  buttons: [
    {
      text: 'inactiveGameModalContent.buttons.0.text',
      className: 'custom-button inactive-game-modal__button',
      callback: 'setState',
      callbackOptions: 'challenges',
    },
    {
      text: 'inactiveGameModalContent.buttons.1.text',
      className: 'custom-button custom-button_gray inactive-game-modal__button',
      callback: 'setState',
      callbackOptions: 'main',
    },
  ],
}

export const activeGameModalContent = {
  buttonText: 'activeGameModalContent.buttonText',
}

export const gameNotAvailableContent = {
  title: 'gameNotAvailableContent.title',
  buttons: [
    {
      text: 'gameNotAvailableContent.buttons.0.text',
      className: 'custom-button inactive-game-modal__button',
    },
  ],
}

export const introScreenContent = {
  img: 'rules/1.png',
  text: 'introScreenContent.text',
  button: {
    className: 'custom-button_yellow intro__button custom-button_show-anim',
    text: 'introScreenContent.button.text',
  },
}

export const getTicketModal = [
  {
    mod: 'textTop w-modal_ticket',
    type: 'gameWin',
    title: 'getTicketModal.0.title',
    setRewards: (tickets) => [{ type: 'ticket', value: tickets }],
    description: 'getTicketModal.0.description',
    rewards: [{ type: 'ticket', value: '1' }],
    buttons: [
      {
        attr: {
          text: 'getTicketModal.0.buttons.0.text',
          className:
            'custom-button procedure-result-modal__button custom-button_show-anim w-modal__button',
        },
        isClose: true,
      },
    ],
  },
  {
    mod: 'textTop w-modal_ticket',
    type: 'gameWin',
    title: 'getTicketModal.1.title',
    setRewards: (tickets) => [{ type: 'ticket', value: tickets }],
    description: 'getTicketModal.1.description',
    rewards: [{ type: 'ticket', value: '1' }],
    buttons: [
      {
        attr: {
          text: 'getTicketModal.1.buttons.0.text',
          className:
            'custom-button procedure-result-modal__button custom-button_show-anim w-modal__button',
        },
        isClose: true,
      },
    ],
    titleData: {
      coin: 'getTicketModal.1.titleData.coin',
      energy: 'getTicketModal.1.titleData.energy',
      ticket: 'getTicketModal.1.titleData.ticket',
      promo: 'getTicketModal.1.titleData.promo',
    },
  },
]

export const mainTopContent = {
  header: {
    addFriendButton: {
      className: 'main__button button_friends button_transparent',
      icon: 'buttons/person',
      gtm: 'GTMFriends',
      redirect: FRIENDS,
      // image: image("main/flower.png"),
    },
    converterButton: {
      icon: 'buttons/conv',
      className: 'main__button-converter custom-button_converter',
    },
  },
  ticketsText: 'mainTopContent.ticketsText',
  raffleText: 'mainTopContent.raffleText',
  raffleImage: image('raffle/back-to-school.png'),
}

export const setsContent = {
  title: 'setsContent.title',
  modalTitle: (id, t) =>
    t('setsContent.modalTitle', {
      id: !id ? t('other.currency.coins.case.genitive') : t('other.currency.gifts.case.genitive'),
    }),
  modalBuyTitle: (id, count, t) => t('setsContent.modalOpenBoxTitle'),
  modalSubtitle: (id, t) =>
    !id ? t('setsContent.modalSubtitleId.coins') : t('setsContent.modalSubtitleId.gifts'),
  tabs: (gameTamagotchiBeauties) => [
    { title: gameTamagotchiBeauties ? 'setsContent.tabs.2.title' : 'setsContent.tabs.0.title' },
    { title: 'setsContent.tabs.1.title' },
  ],
  note: 'setsContent.note',
  boxTitle: {
    bought: (count, type, t) =>
      t('setsContent.boxTitle.bought', {
        count,
        type: getCorrectCase(
          count,
          {
            standard: [t('other.standardVariants.text1'), t('other.standardVariants.text2')],
            rare: [t('other.rareVariants.text1'), t('other.rareVariants.text2')],
          }[type],
        ),
        box: getCorrectCase(count, [t('other.boxVariants.text1'), t('other.boxVariants.text4')]),
      }),
    buy: (count, t) => t('setsContent.boxTitle.buy', { count }),
  },
  boxText: {
    disabled: (type, t) =>
      t('setsContent.boxText.disabled', {
        type: {
          standard: t('other.standardVariants.text2'),
          rare: t('other.rareVariants.text2'),
        }[type],
      }),
    enabled: (count, type, t, gameTamagotchiBeauties) =>
      t('setsContent.boxText.enabled', {
        count,
        type: gameTamagotchiBeauties
          ? null
          : numWord(
              count,
              {
                standard: [
                  t('other.standardVariants.text3'),
                  t('other.standardVariants.text4'),
                  t('other.standardVariants.text4'),
                ],
                rare: [
                  t('other.rareVariants.text3'),
                  t('other.rareVariants.text4'),
                  t('other.rareVariants.text4'),
                ],
              }[type],
            ),
        box: numWord(count, [
          t('other.boxVariants.text1'),
          t('other.boxVariants.text2'),
          t('other.boxVariants.text3'),
        ]),
      }),
  },
  openBtn: {
    attr: {
      text: 'setsContent.openBtn.text',
      className: 'custom-button custom-button_sets',
    },
  },
  gradeData: () => [
    {
      type: 'coin',
      cost: [
        {
          image: image('reward/coin-blue.png'),
          title: 'setsContent.gradeData.0.cost.title',
          text: 'setsContent.gradeData.0.cost.text',
        },
      ],
      prize: {
        bg: image('sets/bg.png'),
        img: image('sets/set-1.png'),
        button: {
          attr: {
            coins: true,
            text: 'setsContent.gradeData.0.prize.button.text',
            className: 'custom-button custom-button_sets sets__prize-button',
            gtm: 'GTMBoxesBuy',
          },
        },
      },
    },
    {
      type: 'gift',
      cost: [
        {
          image: image('reward/gift.png'),
          title: 'setsContent.gradeData.1.cost.title',
          text: 'setsContent.gradeData.1.cost.text',
        },
      ],
      prize: {
        bg: image('sets/bg.png'),
        img: image('sets/set-2.png'),
        button: {
          attr: {
            gifts: true,
            text: 'setsContent.gradeData.1.prize.button.text',
            className:
              'custom-button custom-button_sets custom-button_sets-rare sets__prize-button',
            gtm: 'GTMBoxesBuy',
          },
        },
      },
    },
    {
      type: 'beauties',
      cost: [
        {
          image: image('reward/beauties.png'),
          title: 'setsContent.gradeData.2.cost.title',
          text: 'setsContent.gradeData.2.cost.text',
        },
      ],
      prize: {
        bg: image('sets/bg.png'),
        img: image('sets/set-1.png'),
        button: {
          attr: {
            beauties: true,
            text: 'setsContent.gradeData.2.prize.button.text',
            className: 'custom-button custom-button_sets sets__prize-button',
            gtm: 'GTMBoxesBuy',
          },
        },
      },
    },
  ],
  rewards: {
    title: 'setsContent.rewards.title',
  },
  buyData: {
    buttons: {
      can: [
        {
          attr: {
            text: 'setsContent.buyData.buttons.can.0.text',
            className: 'buy-modal__button lose-modal__button custom-button_price',
          },
          action: 'buy',
        },
        {
          attr: {
            text: 'setsContent.buyData.buttons.can.1.text',
            className: 'buy-modal__button custom-button_gray lose-modal__button',
          },
          action: 'cancel',
        },
      ],
      cant: [
        {
          attr: {
            text: 'setsContent.buyData.buttons.cant.0.text',
            className: 'buy-modal__button lose-modal__button custom-button_price',
          },
          action: 'cancel',
        },
      ],
    },
  },
  availablePrevStates: ['main', 'interactiveShop'],
  toggleData: {
    list: [
      {
        text: 'setsContent.toggle.common',
        action: 'common',
      },
      {
        text: 'setsContent.toggle.rare',
        action: 'rare',
      },
    ],
    settings: {
      width: [50, 50],
    },
  },
}

export const puzzleContent = {
  text: 'puzzleContent.text',
  levels: [],
}

export const procedureGameContent = {
  description: 'procedureGameContent.description',
  button: {
    attr: {
      className: 'procedure-game__button',
      text: 'procedureGameContent.button.text',
    },
  },
}

export const wheelContent = {
  title: 'wheelContent.title',
  titlePrize: 'wheelContent.titlePrize',
  arrow: {
    imgAttr: {
      src: image('wheel/wheel-arrow.png'),
    },
  },
  button: {
    attr: {
      text: 'wheelContent.button.text',
      className: 'wheel__button custom-button_black',
    },
  },
  promocodeModal: {
    mod: 'gifts',
    noXP: true,
    title: null,
    buttons: [
      {
        className: 'win-modal__button button_win',
        tag: 'a',
        target: '_blank',
        text: 'wheelContent.promocodeModal.buttons.0.text',
        disposable: true,
      },
      {
        className: 'win-modal__button custom-button_gray-d',
        text: 'wheelContent.promocodeModal.buttons.1.text',
        callback: 'out',
        disposable: true,
      },
    ],
  },
}

export const shelfContent = {
  title: 'shelfContent.title',
  info: [
    {
      type: 'min',
      reward: {
        type: 'charm',
        value: 'shelfContent.info.giftsReward.value',
      },
      text: 'shelfContent.info.0.text',
    },
  ],
  formattedTasksDefault: {
    daily: {
      title: 'shelfContent.formattedTasksDefault.daily.title',
      list: [],
      completed: 0,
      fresh: 0,
    },
    weekly: {
      title: 'shelfContent.formattedTasksDefault.weekly.title',
      list: [],
      completed: 0,
      fresh: 0,
    },
    others: {
      title: 'shelfContent.formattedTasksDefault.others.title',
      list: [],
      completed: 0,
      fresh: 0,
    },
    special: {
      title: 'shelfContent.formattedTasksDefault.special.title',
      list: [],
      completed: 0,
      fresh: 0,
    },
  },
  animationDelay: (index) => `${0.2 + index * 0.05}s`,
}

const boxPrizeImage = [stores.ru, stores.kz].includes(defaultStore)
  ? image('games/standart-box.png')
  : image('prizes/box-image.png')

export const boxPrizes = [
  {
    image: boxPrizeImage,
    value: 4,
    title: 'boxPrizes.0.title',
    description: 'boxPrizes.0.description',
  },
  {
    image: boxPrizeImage,
    value: 3,
    title: 'boxPrizes.1.title',
    description: 'boxPrizes.1.description',
  },
  {
    image: boxPrizeImage,
    value: 2,
    title: 'boxPrizes.2.title',
    description: 'boxPrizes.2.description',
  },
  {
    image: boxPrizeImage,
    value: 1,
    title: 'boxPrizes.3.title',
    description: 'boxPrizes.3.description',
  },
]

export const boxPrizesSept2026 = [
  {
    image: boxPrizeImage,
    value: 4,
    title: 'boxPrizesSept2026.0.title',
    description: 'boxPrizesSept2026.0.description',
  },
  {
    image: boxPrizeImage,
    value: 3,
    title: 'boxPrizesSept2026.1.title',
    description: 'boxPrizesSept2026.1.description',
  },
  {
    image: boxPrizeImage,
    value: 2,
    title: 'boxPrizesSept2026.2.title',
    description: 'boxPrizesSept2026.2.description',
  },
  {
    image: image('prizes/energy.png'),
    value: 5,
    title: 'boxPrizesSept2026.3.title',
    description: 'boxPrizesSept2026.3.description',
  },
  {
    image: image('prizes/energy.png'),
    value: 3,
    title: 'boxPrizesSept2026.4.title',
    description: 'boxPrizesSept2026.4.description',
  },
]

export const boxPrizesShortTitles = [
  { ...boxPrizes[0], title: 'boxesTextFt.boxPrizesTitle' },
  { ...boxPrizes[1], title: 'boxesTextFt.boxPrizesTitle' },
  { ...boxPrizes[2], title: 'boxesTextFt.boxPrizesTitle' },
  { ...boxPrizes[3], title: 'boxesTextFt.boxPrizesTitle' },
]

export const shopContent = {
  title: 'shopContent.title',
  toggle: {
    character: {
      icon: 'customization/clothes',
      text: 'shopContent.toggle.character.text',
    },
    room: {
      icon: 'customization/room',
      text: 'shopContent.toggle.room.text',
    },
    shower: {
      icon: 'customization/shower',
      text: 'shopContent.toggle.shower.text',
    },
  },
  info: {
    img: image('reward/gift.png'),
    cashback: 'shopContent.info.cashback',
    text: 'shopContent.info.text',
  },
  itemButton: {
    text: {
      absent: 'shopContent.itemButton.text.absent',
      unequipped: 'shopContent.itemButton.text.unequipped',
    },
    icon: { equipped: 'equipped' },
    donHaveStatuses: ['unequipped', 'absent'],
  },
}

export const seasonTaskContent = {
  title: 'seasonTaskContent.title',
  list: [
    {
      title: 'seasonTaskContent.list.0.title',
      list: [
        {
          title: 'seasonTaskContent.list.0.list.0.title',
          text: 'seasonTaskContent.list.0.list.0.text',
        },
        {
          title: 'seasonTaskContent.list.0.list.1.title',
          text: 'seasonTaskContent.list.0.list.1.text',
          button: {
            text: 'seasonTaskContent.list.0.list.1.button.text',
          },
        },
        {
          title: 'seasonTaskContent.list.0.list.2.title',
          text: 'seasonTaskContent.list.0.list.2.text',
        },
      ],
    },
    {
      title: 'seasonTaskContent.list.1.title',
      list: [
        {
          title: 'seasonTaskContent.list.1.list.0.title',
          text: 'seasonTaskContent.list.1.list.0.text',
        },
        {
          title: 'seasonTaskContent.list.1.list.1.title',
          text: 'seasonTaskContent.list.1.list.1.text',
          button: {
            text: 'seasonTaskContent.list.1.list.1.button.text',
          },
        },
        {
          title: 'seasonTaskContent.list.1.list.2.title',
          text: 'seasonTaskContent.list.1.list.2.text',
        },
      ],
    },
    {
      title: 'seasonTaskContent.list.2.title',
      list: [
        {
          title: 'seasonTaskContent.list.2.list.0.title',
          text: 'seasonTaskContent.list.2.list.0.text',
        },
        {
          title: 'seasonTaskContent.list.2.list.1.title',
          text: 'seasonTaskContent.list.2.list.1.text',
          button: {
            text: 'seasonTaskContent.list.2.list.1.button.text',
          },
        },
        {
          title: 'seasonTaskContent.list.2.list.2.title',
          text: 'seasonTaskContent.list.2.list.2.text',
        },
      ],
    },
  ],
  buttonsList: [
    {
      className: 'season-task__button button_tasks',
      text: 'seasonTaskContent.buttonsList.0.text',
    },
    {
      className: 'season-task__button button_tasks custom-button_gray',
      text: 'seasonTaskContent.buttonsList.1.text',
    },
  ],
  winners: {
    img: image('tasks/img.png'),
    title: 'seasonTaskContent.winners.title',
    text: 'seasonTaskContent.winners.text',
    button: {
      className: 'season-task__winners-button button_task-min',
      text: 'seasonTaskContent.winners.button.text',
    },
  },
  info: {
    img: image('tasks/info.svg'),
    text: 'seasonTaskContent.info.text',
  },
  tutorial: {
    img: image('tasks/gift.png'),
    list: [
      {
        title: 'seasonTaskContent.tutorial.list.0.title',
        text: 'seasonTaskContent.tutorial.list.0.text',
      },
      {
        title: 'seasonTaskContent.tutorial.list.1.title',
        text: 'seasonTaskContent.tutorial.list.1.text',
      },
    ],
    button: {
      className: 'tutorial-modal__button',
      text: 'seasonTaskContent.tutorial.button.text',
    },
  },
}

export const nyTaskContent = {
  item: {
    week: 'nyTaskContent.item.week',
  },
  note: {
    img: image('tasks/info.svg'),
    text: 'nyTaskContent.note.text',
  },
  quizDescriptions: {
    isCompleted: 'nyTaskContent.quizDescriptions.isCompleted',
    isAvailable: 'nyTaskContent.quizDescriptions.isAvailable',
    isAccessibly: 'nyTaskContent.quizDescriptions.isAccessibly',
  },
  buttonsList: [
    {
      className: 'ny-task__button button_tasks',
      text: 'nyTaskContent.buttonsList.0.text',
      action: 'openInfo',
    },
    {
      className: 'ny-task__button button_tasks custom-button_white',
      text: 'nyTaskContent.buttonsList.1.text',
      action: 'back',
    },
  ],
  quizButton: {
    text: 'nyTaskContent.quizButton.text',
  },
  quiz: {
    button: { text: 'nyTaskContent.quiz.button.text' },
    result: {
      title: 'nyTaskContent.quiz.result.title',
    },
  },
  promocodeModal: {
    type: 'wModal',
    props: {
      type: 'gameWin',
      title: 'nyTaskContent.promocodeModal.props.title',
      description: 'nyTaskContent.promocodeModal.props.description',
      rewards: [{ type: 'promo', value: 1 }],
      buttons: [
        {
          attr: {
            text: 'nyTaskContent.promocodeModal.props.buttons.0.text',
            className: 'custom-button custom-button_yellow',
          },
          isClose: true,
        },
      ],
      selfClose: true,
    },
  },
  ticketModal: {
    type: 'wModal',
    props: {
      type: 'gameWin',
      title: 'nyTaskContent.ticketModal.props.title',
      description: 'nyTaskContent.ticketModal.props.description',
      rewards: [{ type: 'ticket', value: 1 }],
      buttons: [
        {
          attr: {
            text: 'nyTaskContent.ticketModal.props.buttons.0.text',
            className: 'custom-button custom-button_yellow',
          },
          isClose: true,
        },
      ],
      selfClose: true,
    },
  },
  button: {
    className: 'ny-task__item-button button_task button_task-ny',
    text: 'nyTaskContent.button.text',
  },
  winners: {
    button: {
      className: 'ny-task__winners-button button_task-min',
      text: 'nyTaskContent.winners.button.text',
    },
  },
  tutorial: {
    type: 'season-task',
    list: [
      // {
      //   img: image("tutorialModal/1.png"),
      //   title: "nyTaskContent.tutorial.list.0.title",
      //   text: "nyTaskContent.tutorial.list.0.text",
      //   button: { text: "nyTaskContent.tutorial.list.0.button.text" }
      // },
      // {
      //   img: image("tutorialModal/2.png"),
      //   title: "nyTaskContent.tutorial.list.1.title",
      //   text: "nyTaskContent.tutorial.list.1.text",
      //   button: { text: "nyTaskContent.tutorial.list.1.button.text" }
      // },
      // {
      //   img: image("tutorialModal/3.png"),
      //   title: "nyTaskContent.tutorial.list.2.title",
      //   text: "nyTaskContent.tutorial.list.2.text",
      //   button: { text: "nyTaskContent.tutorial.list.2.button.text" }
      // },
      {
        img: image('tutorialModal/7.png'),
        title: 'nyTaskContent.tutorial.list.3.title',
        text: 'nyTaskContent.tutorial.list.3.text',
        button: { text: 'nyTaskContent.tutorial.list.3.button.text' },
      },
    ],
    button: { className: 'tutorial-modal__button' },
  },
  prizesTutorial: {
    type: 'season-task',
    list: [
      {
        img: image('tutorialModal/2.png'),
        title: 'nyTaskContent.prizesTutorial.list.0.title',
        text: 'nyTaskContent.prizesTutorial.list.0.text',
        button: { text: 'nyTaskContent.prizesTutorial.list.0.button.text' },
      },
      {
        img: image('tutorialModal/3.png'),
        title: 'А если я не успею?',
        text: 'За&nbsp;каждый тест ты&nbsp;получишь награду. Для участия в&nbsp;розыгрыше призов нужно пройти все пять.',
        button: { text: 'Дальше' },
      },
    ],
    button: { className: 'tutorial-modal__button' },
  },
  afterAnswerModal: {
    type: 'info',
    button: { text: 'nyTaskContent.afterAnswerModal.button.text' },
  },
  successQuizModal: {
    buttons: [
      {
        attr: { text: 'nyTaskContent.successQuizModal.button.text' },
      },
    ],
  },
}

export const nyTaskPrizeContent = {
  navigation: {
    arrows: {
      nextEl: '.ny-task__prize-nav-item_next',
      prevEl: '.ny-task__prize-nav-item_prev',
    },
    buttons: [
      {
        className: 'custom-button_prize-nav ny-task__prize-nav-item ny-task__prize-nav-item_prev',
        icon: 'buttons/nav-prev',
      },
      {
        className: 'custom-button_prize-nav ny-task__prize-nav-item ny-task__prize-nav-item_next',
        icon: 'buttons/nav-next',
      },
    ],
  },
}

export const tasksContent = {
  buttons: {
    showPrizes: {
      btnMod: 'showPrizes',
      className:
        'button_task task__item-button custom-button_challenge task__item-button_showPrizes',
      text: 'other.whatWillGet',
    },
    extraButton: {
      btnMod: 'extraButton',
      className: 'button_task task__item-button custom-button_challenge',
      text: 'other.go',
    },
  },
}

export const goldAppleLink = 'links.index'

export const errorConfig = {
  defaultError: {
    title: 'errors.default.title',
    text: 'errors.default.text',
    button: 'errors.default.button',
  },
  'not enough beauties': {
    title: 'errors.notEnoughBeauties.title',
    text: 'errors.notEnoughBeauties.text',
    button: 'errors.notEnoughBeauties.button',
  },
  'customer not found': {
    title: 'errors.customerNotFound.title',
    text: 'errors.customerNotFound.text',
    button: 'errors.customerNotFound.button',
  },
}

export const august2026ChangesData = {
  challenges: {
    serviceDataKey: 'challengesAugust2026',
    image: 'august2026/challenges.png',
    title: 'changesAugust2026Modals.challenges.title',
    description: 'changesAugust2026Modals.challenges.description',
    button: 'changesAugust2026Modals.challenges.button',
  },
  customization: {
    serviceDataKey: 'customizationAugust2026',
    image: 'august2026/customization.png',
    title: 'changesAugust2026Modals.customization.title',
    description: 'changesAugust2026Modals.customization.description',
    button: 'changesAugust2026Modals.customization.button',
  },
  sets: {
    serviceDataKey: 'setsAugust2026',
    image: 'august2026/sets.png',
    title: 'changesAugust2026Modals.sets.title',
    description: 'changesAugust2026Modals.sets.description',
    button: 'changesAugust2026Modals.sets.button',
  },
}

export const sept2026ChangesRatingData = {
  rating: {
    serviceDataKey: 'ratingSept2026',
    image: 'sept2026/rating.png',
    title: 'sept2026ChangesRating.rating.title',
    description: 'sept2026ChangesRating.rating.description',
    button: 'sept2026ChangesRating.rating.button',
  },
  gameRating: {
    serviceDataKey: 'gameRatingSept2026',
    image: 'sept2026/gameRating.png',
    title: 'sept2026ChangesRating.gameRating.title',
    description: 'sept2026ChangesRating.gameRating.description',
    button: 'sept2026ChangesRating.gameRating.button',
  },
}
